//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ASCVD',
  data() {
    return {
      defaultJson: {
        'Baseline': '基线',
        'Baseline risk is the risk for this patient with optimal risk factors': '基线风险是指按照最优风险因子评估的患者风险',
        'HDL-Cholesterol': 'HDL',
        'Other': '其他',
        'Treatment for high BP': '降压治疗',
        'Black': '黑人',
        'Diabetes': '糖尿病',
        '10 Year Risk': '10 年风险',
        'Systolic BP': '收缩压',
        'Only valid for ages 40 to 79': '仅对年龄介于 40 至 79 岁有效',
        'Total Cholesterol': '总胆固醇',
        'Age': '年龄',
        'Race': '种族',
        'Smoker': '吸烟'
      },
      form: {
        age: '',
        gender: '',
        black: '',
        tchol: '',
        hdl: '',
        sbp: '',
        bptreat: '0',
        diabetes: '0',
        smoker: '0'
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '0', name: '男' },
        { value: '1', name: '女' }
      ],
      dataList2: [
        { value: '1', name: '黑人' },
        { value: '0', name: '其他' }
      ],
      logit: '...'
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key] && key !== 'drop') {
            flag = false
          } else {
            if (form[key] === '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(4444, flag)

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let bp = 0
        var ageCoeff = form.black ? (form.gender ? 17.1141 : 2.469) : (form.gender ? -29.799 : 12.344)
        var age2Coeff = form.black ? (form.gender ? 0 : 0) : (form.gender ? 4.884 : 0)
        var tcholCoeff = form.black ? (form.gender ? 0.9396 : 0.302) : (form.gender ? 13.54 : 11.853)
        var tcholAgeCoeff = form.black ? (form.gender ? 0 : 0) : (form.gender ? -3.114 : -2.664)
        var hdlCoeff = form.black ? (form.gender ? -18.9196 : -0.307) : (form.gender ? -13.578 : -7.99)
        var hdlAgeCoeff = form.black ? (form.gender ? 4.4748 : 0) : (form.gender ? 3.149 : 1.769)
        var sbpCoeff = form.black ? (form.gender ? 27.8197 : 1.809) : (form.gender ? 1.957 : 1.764)
        var sbpAgeCoeff = form.black ? (form.gender ? -6.0873 : 0) : (form.gender ? 0 : 0)
        var sbpTreatCoeff = form.black ? (form.gender ? 29.2907 : 1.916) : (form.gender ? 2.019 : 1.797)
        var sbpAgeTreatCoeff = form.black ? (form.gender ? -6.4321 : 0) : (form.gender ? 0 : 0)
        var diabetesCoeff = form.black ? (form.gender ? 0.8738 : 0.645) : (form.gender ? 0.661 : 0.658)
        var smokerCoeff = form.black ? (form.gender ? 0.6908 : 0.549) : (form.gender ? 7.574 : 7.837)
        var smokerAgeCoeff = form.black ? (form.gender ? 0 : 0) : (form.gender ? -1.665 : -1.795)
        var baseline = form.black ? (form.gender ? 0.95334 : 0.89536) : (form.gender ? 0.96652 : 0.91436)
        var mean = form.black ? (form.gender ? 86.6081 : 19.5425) : (form.gender ? -29.1817 : 61.1816)
        bp = form.bptreat ? (
          Math.log(form.sbp) * sbpTreatCoeff + Math.log(form.age) * Math.log(form.sbp) * sbpAgeTreatCoeff
        ) : (
          Math.log(form.sbp) * sbpCoeff + Math.log(form.age) * Math.log(form.sbp) * sbpAgeCoeff
        )
        /* 
        Math.log(form.age) * ageCoeff=45.535527981582429722410713131183
        Math.pow(Math.log(form.age), 2) * age2Coeff=0
        Math.pow(Math.log(form.age), 2 * age2Coeff)=1
        Math.log(form.tchol) * tcholCoeff=54.589687384702835076698541407657
        Math.log(form.age) * Math.log(form.tchol) * tcholAgeCoeff=-45.2558127042873
        Math.log(form.hdl) * hdlCoeff=-28.632316318264318912983388186924
        Math.log(form.age) * Math.log(form.hdl) * hdlAgeCoeff=23.384710642947603
        bp=8.446763217328972
        form.diabetes * diabetesCoeff=0.658
        form.smoker * smokerCoeff=7.837
        form.smoker * Math.log(form.age) * smokerAgeCoeff=-6.621538620134515

        js=59.93741641368972
        calc=59.942021583875705886125866351916
        */
        var risk = Math.log(form.age) * ageCoeff +
          Math.pow(Math.log(form.age), 2) * age2Coeff +
          Math.log(form.tchol) * tcholCoeff +
          Math.log(form.age) * Math.log(form.tchol) * tcholAgeCoeff +
          Math.log(form.hdl) * hdlCoeff +
          Math.log(form.age) * Math.log(form.hdl) * hdlAgeCoeff +
          bp +
          form.diabetes * diabetesCoeff +
          form.smoker * smokerCoeff +
          form.smoker * Math.log(form.age) * smokerAgeCoeff

        /*
        Math.log(form.age) * ageCoeff=45.535527981582429722410713131183
        Math.pow(Math.log(form.age), 2) * age2Coeff=0
        Math.pow(Math.log(form.age), 2 * age2Coeff)=1
        Math.log(170) * tcholCoeff=60.874618874356756
        Math.log(form.age) * Math.log(170) * tcholAgeCoeff=-50.47038931618739
        Math.log(50) * hdlCoeff=-31.257063813370888
        Math.log(form.age) * Math.log(50) * hdlAgeCoeff=25.528405899789796
        Math.log(110) * sbpCoeff =8.291647365257823
        Math.log(form.age) * Math.log(110) * sbpAgeCoeff=0
        js=58.50274699142853
        calc=58.50274699142853
        */
        var baseRisk = Math.log(form.age) * ageCoeff +
          Math.pow(Math.log(form.age), 2) * age2Coeff +
          Math.log(170) * tcholCoeff +
          Math.log(form.age) * Math.log(170) * tcholAgeCoeff +
          Math.log(50) * hdlCoeff +
          Math.log(form.age) * Math.log(50) * hdlAgeCoeff +
          Math.log(110) * sbpCoeff + Math.log(form.age) * Math.log(110) * sbpAgeCoeff

        var year10 = (100 * (1 - Math.pow(baseline, (Math.pow(Math.E, (risk - mean)))))).toFixed(1)
        var year10Base = (100 * (1 - Math.pow(baseline, (Math.pow(Math.E, (baseRisk - mean)))))).toFixed(1)
        self.hasScore = true
        // debugger
        console.log(year10, year10Base)

        self.logit = self.defaultJson['(of massive transfusion)']
        return {
          year10: String(year10),
          year10Base: String(year10Base)
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/ASCVD.vue